export default __webpack_public_path__ + "static/hiv-landscape-section-hero-mobile-42e7a05bac37ceb31c578cc5a353cb6b.png";